module.exports = __webpack_public_path__ + "img/logo-friboi.ce96e401.png";